module.exports = __webpack_public_path__ + "static/img/3.f571c0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/sp/3.png
// module id = MJNb
// module chunks = 0